"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalFormTipologia = ModalFormTipologia;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _style = _interopRequireDefault(require("./style"));

var _styles = require("@mui/styles");

var _material = require("@mui/material");

var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));

var _DeleteOutlined = _interopRequireDefault(require("@mui/icons-material/DeleteOutlined"));

var _HelpOutlineOutlined = _interopRequireDefault(require("@mui/icons-material/HelpOutlineOutlined"));

var _Select = _interopRequireDefault(require("../../dist/Select"));

var _getSelectOptions = require("../../utils/getSelectOptions");

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Transition = /*#__PURE__*/_react.default.forwardRef(function Transition(props, ref) {
  return (0, _react2.jsx)(_material.Slide, _extends({
    direction: "up",
    ref: ref
  }, props));
});

function ModalFormTipologia(props) {
  const {
    capacidad_max,
    dormitorios,
    banios,
    open,
    openModal,
    onChangeSelect,
    onBlurInput,
    nombre,
    descripcion,
    unidades,
    guardar,
    agregarUnidad,
    cant,
    onChangeCant,
    onBlurInputUnidad,
    onDeleteUnidad,
    errors
  } = props;
  const theme = (0, _styles.useTheme)();
  const classes = (0, _style.default)(theme);
  const unidadesAMostrar = unidades.filter(u => {
    return !u.delete || u.delete === 0;
  });

  const [openTooltip, setOpen] = _react.default.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const isMobile = (0, _material.useMediaQuery)(theme.breakpoints.down('sm'));
  return (0, _react2.jsx)(_material.Dialog, {
    open: open,
    onClose: () => openModal(false),
    TransitionComponent: Transition,
    fullScreen: isMobile
  }, (0, _react2.jsx)(_material.AppBar, {
    css: classes.appBar
  }, (0, _react2.jsx)(_material.Toolbar, null, (0, _react2.jsx)(_material.IconButton, {
    edge: "start",
    color: "inherit",
    onClick: () => openModal(false),
    "aria-label": "close"
  }, (0, _react2.jsx)(_Close.default, null)), (0, _react2.jsx)(_material.Typography, {
    variant: "h6",
    css: classes.title
  }, "Agregar Tipolog\xEDa"), (0, _react2.jsx)(_material.Button, {
    autoFocus: true,
    color: "inherit",
    onClick: guardar
  }, "Guardar"))), (0, _react2.jsx)(_material.List, {
    css: classes.containerForm
  }, (0, _react2.jsx)(_material.Typography, {
    variant: "subtitle2",
    css: classes.subtitulo
  }, "Tipolog\xEDa"), (0, _react2.jsx)(_material.Grid, {
    container: true
  }, (0, _react2.jsx)(_material.Grid, {
    item: true,
    xs: 10
  }, (0, _react2.jsx)(_material.FormControl, {
    error: errors.nombreTipologiaError,
    css: classes.inputFormControl,
    fullWidth: true,
    "aria-describedby": "nombre-tipologia-text"
  }, (0, _react2.jsx)(_material.Input, {
    onBlur: onBlurInput,
    defaultValue: nombre,
    css: classes.input,
    inputProps: {
      'data-estado': 'nombre'
    },
    placeholder: "Nombre Tipolog\xEDa"
  }), errors.capacidadError ? (0, _react2.jsx)(_material.FormHelperText, null, "El nombre de la tipologia es obligatorio") : null)), (0, _react2.jsx)(_material.Grid, {
    item: true,
    xs: 2,
    css: classes.tooltip
  }, isMobile ? (0, _react2.jsx)(_material.Tooltip, {
    onClose: handleTooltipClose,
    onClick: handleTooltipOpen,
    open: openTooltip,
    disableHoverListener: true,
    disableTouchListener: true,
    title: "Si ten\xE9s m\xE1s de UNA unidad dentro de la tipolog\xEDa, es necesario que las describas con un nombre para que las identifiques."
  }, (0, _react2.jsx)(_material.IconButton, {
    "aria-label": "delete"
  }, (0, _react2.jsx)(_HelpOutlineOutlined.default, null))) : (0, _react2.jsx)(_material.Tooltip, {
    title: "Si ten\xE9s m\xE1s de UNA unidad dentro de la tipolog\xEDa, es necesario que las describas con un nombre para que las identifiques."
  }, (0, _react2.jsx)(_material.IconButton, {
    "aria-label": "delete"
  }, (0, _react2.jsx)(_HelpOutlineOutlined.default, null)))), (0, _react2.jsx)(_material.Grid, {
    item: true,
    xs: 12
  }, (0, _react2.jsx)(_Select.default, {
    name: "capacidad_max",
    placeholder: "Capacidad m\xE1xima",
    value: capacidad_max !== null ? capacidad_max : '',
    onChange: onChangeSelect,
    nameOfTheKeyWithTheValue: "value",
    nameOfTheKeyWithTheLabel: "label",
    data: _getSelectOptions.selectCapacidad,
    error: errors.capacidadError,
    campo: "capacidad"
  }), (0, _react2.jsx)(_Select.default, {
    name: "dormitorios",
    placeholder: "Dormitorios",
    value: dormitorios !== null ? dormitorios : '',
    onChange: onChangeSelect,
    nameOfTheKeyWithTheValue: "value",
    nameOfTheKeyWithTheLabel: "label",
    data: _getSelectOptions.selectDormitorios,
    error: errors.dormitorioError,
    campo: "dormitorios"
  }), (0, _react2.jsx)(_Select.default, {
    name: "banios",
    placeholder: "Ba\xF1os",
    value: banios !== null ? banios : '',
    onChange: onChangeSelect,
    nameOfTheKeyWithTheValue: "value",
    nameOfTheKeyWithTheLabel: "label",
    data: _getSelectOptions.selectBano,
    error: errors.baniosError,
    campo: "ba\xF1os"
  })), (0, _react2.jsx)(_material.Grid, {
    item: true,
    xs: 12
  }, (0, _react2.jsx)(_material.FormControl, {
    css: classes.inputFormControl,
    fullWidth: true,
    "aria-describedby": "descripcion-text"
  }, (0, _react2.jsx)(_material.Input, {
    css: classes.input,
    onBlur: onBlurInput,
    defaultValue: descripcion,
    inputProps: {
      'data-estado': 'descripcion'
    },
    placeholder: "Descripci\xF3n"
  }))), (0, _react2.jsx)(_material.Typography, {
    variant: "subtitle2",
    css: classes.subtitulo
  }, "Unidades"), unidadesAMostrar && unidadesAMostrar.map(u => {
    return (0, _react2.jsx)(_material.Grid, {
      container: true,
      key: u.id
    }, (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 6,
      md: 7
    }, (0, _react2.jsx)(_material.FormControl, {
      fullWidth: true,
      css: classes.input,
      "aria-describedby": "nombre-unidad-text"
    }, (0, _react2.jsx)(_material.InputLabel, {
      htmlFor: "link-propio"
    }, "Nombre Unidad"), (0, _react2.jsx)(_material.Input, {
      defaultValue: u.nombre,
      onBlur: e => onBlurInputUnidad(u.id, e.target.value),
      inputProps: {
        'data-estado': 'nombre_unidad'
      }
    }))), (0, _react2.jsx)(_material.Grid, {
      item: true,
      css: classes.deleteUnidad,
      xs: 6,
      md: 4
    }, (0, _react2.jsx)(_material.Button, {
      onClick: () => onDeleteUnidad(u.id)
    }, (0, _react2.jsx)(_DeleteOutlined.default, {
      css: classes.buttonDeleteUnidad
    }))));
  }), (0, _react2.jsx)(_material.Grid, {
    container: true,
    css: classes.cantUnidades
  }, (0, _react2.jsx)(_material.Grid, {
    item: true,
    xs: 6,
    md: 4,
    css: classes.contenedorCantUnidades
  }, (0, _react2.jsx)(_material.Typography, null, "Agregar"), (0, _react2.jsx)(_material.FormControl, {
    fullWidth: true,
    css: classes.inputCanUnidades,
    "aria-describedby": "cant-unidad-text"
  }, (0, _react2.jsx)(_material.Input, {
    defaultValue: cant,
    onBlur: onChangeCant
  })), (0, _react2.jsx)(_material.Typography, null, "unidades")), (0, _react2.jsx)(_material.Grid, {
    item: true,
    xs: 4,
    md: 2,
    css: classes.botonAgregar
  }, (0, _react2.jsx)(_material.Button, null, (0, _react2.jsx)(_material.Typography, {
    onClick: agregarUnidad,
    css: classes.botonAgregar
  }, "agregar")))))));
}

var _default = ModalFormTipologia;
exports.default = _default;